module.exports = __webpack_public_path__ + "img/04.b4018a65.jpg";